import type { StorefrontCategory } from "../types/storefront";

const categorySets: Record<string, Array<[string, string]>> = {
  meyar: [
    ["Groceries", "grc.webp"],
    ["Beverages", "bev.webp"],
    ["Dairy & Breakfast", "dry.webp"],
    ["Biscuits & Snacks", "bis.webp"],
    ["Personal Care", "per.webp"],
    ["Home Cleaning", "cln.webp"],
    ["Baby Care", "bby.webp"],
    ["Health & Wellness", "hlt.webp"],
    ["Kitchen", "kit.webp"],
    ["Pet Care", "pet.webp"]
  ],
  freshmart: [
    ["Fresh Produce", "frz.webp"],
    ["Dairy", "dry.webp"],
    ["Bakery", "brk.webp"],
    ["Rice & Pulses", "ric.webp"],
    ["Spices", "spc.webp"],
    ["Beverages", "bev.webp"],
    ["Breakfast", "tea.webp"],
    ["Frozen", "frz.webp"]
  ],
  royalbakery: [
    ["Celebration Cakes", "brk.webp"],
    ["Pastries", "bis.webp"],
    ["Artisan Bread", "flr.webp"],
    ["Cookies", "bis.webp"],
    ["Savory", "snk.webp"],
    ["Cafe Drinks", "tea.webp"],
    ["Desserts", "sgr.webp"],
    ["Gift Boxes", "brk.webp"]
  ],
  urbanstyle: [
    ["Women", "cos.webp"],
    ["Men", "per.webp"],
    ["Beauty", "cos.webp"],
    ["Accessories", "kit.webp"],
    ["Home", "kit.webp"],
    ["Wellness", "hlt.webp"],
    ["Gifts", "sta.webp"],
    ["Travel", "pls.webp"]
  ]
};

const slugify = (value: string) => value.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const mockCategories: StorefrontCategory[] = Object.entries(categorySets).flatMap(
  ([tenantSlug, categories]) =>
    categories.map(([name, image], index) => ({
      id: `${tenantSlug}-cat-${index + 1}`,
      tenantSlug,
      name,
      slug: slugify(name),
      description: `Explore ${name.toLowerCase()} selected for ${tenantSlug}.`,
      image: `/catalog/${image}`,
      sortOrder: index
    }))
);
